module.exports = __webpack_public_path__ + "img/5c.6bec540c.png";